import styled, { css } from 'react-emotion'

export const playlistContainer = css`
  position: relative;
  display: inline-block;
  border-radius: 0.25rem;
  transition: all ease 500ms;
  width: 100%;
  overflow: hidden;

  .resumeWrapper img {
    width: 100%;
    height: 100%;
  }

  .fallbackImg {
    width: 100%;
    height: 100%;
  }

  .imageWrapper.loaded {
    width: 100%;
  }

  .imageWrapper .imageBorder {
    opacity: 0;
    height: 100%;
    width: 100%;
    display: block;
    position: absolute;
    border: 4px solid #1F93FF;
    box-sizing: border-box;
    z-index: 2;
    transition: opacity 0.3s;
  }

  .imageWrapper.loaded:hover .imageBorder {
    opacity: 1;
    transition: opacity 0.3s;
  }

  .imageWrapper.loaded:hover .bannerImage {
    transform: scale(1.05);
    transition: transform 0.3s;
  }

  .imageWrapper .bannerImage {
    transition: transform 0.3s;
  }

  .imageWrapper.loaded:hover {
    overflow: hidden;
    border-radius: 0.3rem;
  }
  
  .imageWrapper.loaded {
    height: auto;
    box-sizing: border-box;
    transition: border 0.2s;
    overflow: hidden;
  }

  p {
    position: relative;
    height: 3.05rem !important;
    line-height: 1.5;
    font-size: 1.1rem !important;
    max-width: 100%;
    text-overflow: clip;
    overflow: hidden;
    padding: 0 0.15rem;
    color: white;
    // opacity: 0;
    transition: all ease 500ms;

    @media screen and (max-width: 640px) {
      opacity: 1;
      max-width: 100%;
      font-size: 12px !important;
      line-height: 14px;
      height: 28px !important;
      text-overflow: clip;
    }
  }

  :hover p {
    opacity: 1;
  }

  .bannerImage {
    display: inline-block;
    // border-radius: 0.25rem 0.25rem 0 0;
    position: relative;
    z-index: 1;
  }

  .title {
    color: #fff;
    font-weight: bold;
    font-size: 1.6rem !important;
    height: auto !important;
    min-height: 2.24rem;
    max-height: 4.48rem;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: .25rem 0;

    @media screen and (max-width: 640px) {
      font-size: 14px !important;
      min-height: 20px;
      max-height: 40px;
      margin: 0;
    }
  }

  .bannerImage.hide,
  .bannerPlaceholder {
    position: absolute;
    z-index: 0;
  }

  .bannerImage3d {
    display: inline-block;
    border-radius: 0.25rem;
    position: relative;
    z-index: 1;
    width: 100%;
  }

  .bannerImage3d.hide {
    position: absolute;
    z-index: 0;
  }

  .wrapperBar {
    width: 100%;
    background-color: #fff;
    height: 5px;
  }
`

export const imageWrapper = css`
  position: relative;
  display: inline-block;
  text-align: left;
  overflow: hidden;
  width: 100%;
`

export const ProgressBar = styled('div')`
  position: relative;
  z-index: 1;
  width: 100%;
  background-color: #4E6376;
  height: 4px;
  // border-radius: 0rem 0rem 0.25rem 0.25rem;
  // margin-bottom: 10px;
  margin-top: -2px;

  span {
    height: 4px;
    width: ${props => props.width};
    background-color: #1F93FF;
    display: block;
    // border-radius: 0rem 0rem 0rem 0.25rem;
  }
`

export const SpecialRibbon = styled('div')`
  background-image: url('${props => props.imgUrl}');
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 2;
`